import { createAction } from 'redux-actions';
import { push } from 'react-router-redux';

import { getAllHotelData } from './hotel';

export const changeLanguage = createAction('CHANGE_LANGUAGE', lan => dispatch => {
	dispatch(getAllHotelData());
	return { lan };
});

export const languagePathRedirect = createAction(
	'LANGUAGE_PATH_REDIRECT',
	lan => (dispatch, getState) => {
		const { routing: { locationBeforeTransitions: { pathname } } } = getState();

		let newPathname = '';

		// For smart language direct.
		if (pathname !== '/') {
			let pathnames = pathname.split('/');

			// Normalize pathname
			if (pathnames[0] !== '') {
				pathnames = ['', ...pathnames];
			}

			// home page language redirect
			if (pathnames.length === 2) {
				pathnames.push(lan);
				newPathname = pathnames.join('/');
			}

			// hotel page language redirect
			if (pathnames.length >= 3) {
				pathnames[2] = lan;
				newPathname = pathnames.join('/');
			}
		} else {
			// If user is at homepage or illegal path,
			// just redirect to main page with language
			newPathname = `/main/${lan}`;
		}

		dispatch(push({ pathname: newPathname }));
	},
);



// WEBPACK FOOTER //
// ./src/actions/i18n.js